const State = {}

export default State
